import Icon from "@/components/ui/icon";
import { Tooltip } from "@/components/ui/tooltip";
import { copyToClipboard } from "@/lib/utils/index";
import { useTheme } from "next-themes";
import { memo } from "react";
import { Prism as SyntaxHighlighter } from "react-syntax-highlighter";
import {
  cb,
  vscDarkPlus,
} from "react-syntax-highlighter/dist/esm/styles/prism";

export interface CodeBlockProps {
  language: string;
  value: string;
}

const CodeBlock = memo(({ language, value }: CodeBlockProps) => {
  const { resolvedTheme } = useTheme();

  return (
    <div className="relative my-4">
      <SyntaxHighlighter
        language={language}
        className="rounded-lg text-sm"
        customStyle={{
          paddingTop: "28px",
          backgroundColor: resolvedTheme === "dark" ? "black" : "#383838",
        }}
        showLineNumbers={false}
        useInlineStyles={true}
        wrapLongLines={true}
        style={resolvedTheme === "dark" ? vscDarkPlus : cb}
      >
        {value}
      </SyntaxHighlighter>
      <Tooltip
        trigger={
          <div
            className="w-min ml-2 cursor-pointer absolute top-2 right-2 text-sm px-2"
            onClick={() => {
              copyToClipboard(value, "Code copied to clipboard");
            }}
            onKeyUp={(e) => {
              if (e.key === "Enter") {
                copyToClipboard(value, "Code copied to clipboard");
              }
            }}
          >
            <Icon
              className="fill-primaryaccent hover:fill-black dark:hover:fill-white"
              icon="copy"
            />
          </div>
        }
        providerProps={{ delayDuration: 200 }}
        contentProps={{ side: "bottom" }}
        className="font-montserrat"
      >
        Copy Content
      </Tooltip>
    </div>
  );
});

CodeBlock.displayName = "CodeBlock";

export default CodeBlock;
